export default __webpack_public_path__ + "static/media/Dll.0fabde0a.png";